import React, { useState, useEffect, useCallback, memo, useRef } from 'react';
import ReactFlow, {
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  Handle,
  Position,
  Panel,
} from 'reactflow';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateFlowchart, getFlowchartById, generateFlowchartFromDescription } from '../../store/actions/flowchartActions';
import { openOverlay, closeOverlay, getRisk } from '../../store/actions/riskActions';
import TopBar from '../TopBar';
import RiskDetailsForm from '../Risk/RiskOverlay';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import 'reactflow/dist/style.css';
import ControlOverlay from '../Control/ControlOverlay';
import ActionOverlay from '../Action/ActionOverlay';
import { BsStars } from "react-icons/bs";
import { RiFlowChart } from "react-icons/ri";
import { compose } from 'redux'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { toPng } from 'html-to-image';
import jsPDF from 'jspdf';
import { getRectOfNodes, getTransformForBounds } from 'reactflow';
import { NodeResizer } from '@reactflow/node-resizer';
import '@reactflow/node-resizer/dist/style.css';


const RiskNode = memo(({ data }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const truncateText = (text, maxLength = 30) => {
    if (!text) return '';
    return text?.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    if (data.setActiveRiskForWorkflow) {
      data.setActiveRiskForWorkflow(data.id);
    }
    if (data.setMenuItem) {
      data.setMenuItem('risk');
    }
  };



  const handleClick = (event) => {
    event.preventDefault();

    // Check if we have a valid ID
    if (!data.id) {
      return;
    }

    // First open the overlay with the risk ID
    dispatch(openOverlay(data.id));

    // Then fetch the risk data
    dispatch(getRisk(data.id));

    if (data.setActiveRiskForWorkflow) {
      data.setActiveRiskForWorkflow(data.id);
    }
    if (data.setMenuItem) {
      data.setMenuItem('risk');
    }
  };

  return (
    <div
      className="system-node risk-node"
      onContextMenu={handleContextMenu}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="system-header" style={{ background: '#e74c3c' }}>Risk</div>
      <div className="system-content">
        <strong title={data.name}>{truncateText(data.name)}</strong><br />
        ID: {data.id}<br />
        {/* {truncateText(data.definition, 50)} */}
      </div>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={true}
      />
    </div>
  );
});

const AssetNode = memo(({ data }) => {
  const handleContextMenu = (event) => {
    event.preventDefault();
    if (data.setMenuItem) {
      ////console.log('setting menu item to asset');
      data.setMenuItem('inventory');
    }
    if (data.setActiveAssetForWorkflow) {
      data.setActiveAssetForWorkflow(data.id);
    }
  };

  return (
    <div
      className="system-node asset-node"
      onContextMenu={handleContextMenu}
    >
      <div className="system-header" style={{ background: '#27ae60' }}>Asset</div>
      <div className="system-content">
        <strong>{data.name}</strong><br />
        ID: {data.id}<br />
        {data.description}
      </div>
      {/* <Handle
        type="target"
        position={Position.Top}
        isConnectable={true}
      /> */}
      <Handle
        type="target"
        position={Position.Bottom}
        isConnectable={true}
      />
    </div>
  );
});

const handleStyle = {
  background: '#9CA3AF',
  width: 10,
  height: 10,
  border: '2px solid #fff',
  boxShadow: '0 0 0 1px #D1D5DB',
};

const resizerColor = '#2563EB';

const getEdgeLabelStyles = (label) => {
  const value = String(label || '').trim().toLowerCase();

  if (value === 'yes') {
    return {
      labelStyle: { fontSize: 12, fontWeight: 600, fill: '#166534' },
      labelBgStyle: {
        fill: '#DCFCE7',
        stroke: '#86EFAC',
        strokeWidth: 1,
      },
    };
  }

  if (value === 'no') {
    return {
      labelStyle: { fontSize: 12, fontWeight: 600, fill: '#991B1B' },
      labelBgStyle: {
        fill: '#FEE2E2',
        stroke: '#FCA5A5',
        strokeWidth: 1,
      },
    };
  }

  return {
    labelStyle: { fontSize: 12, fontWeight: 600, fill: '#1E40AF' },
    labelBgStyle: {
      fill: '#DBEAFE',
      stroke: '#93C5FD',
      strokeWidth: 1,
    },
  };
};

const VerticalLabelBlock = memo(({ data, id }) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '50px',
        backgroundColor: 'white',
        border: '1.5px solid #6B7280',
        writingMode: 'vertical-lr',
        textOrientation: 'upright',
        fontWeight: 'bold',
        fontSize: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        pointerEvents: 'auto',
        cursor: 'text',
        padding: '10px 2px',
        boxSizing: 'border-box',
        margin: '10px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
      }}
      onDoubleClick={() => setIsEditing(true)}
    >
      {isEditing ? (
        <input
          type="text"
          value={data.label || ''}
          onChange={(e) => data.onChange(id, e.target.value, 'label')}
          autoFocus
          onBlur={() => setIsEditing(false)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              setIsEditing(false);
            }
          }}
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '14px',
            writingMode: 'vertical-lr',
            textOrientation: 'upright',
            letterSpacing: '3px',
            width: '100%',
            height: '100%',
            outline: 'none',
            textAlign: 'center',
            padding: 0,
            margin: 0,
            fontWeight: 'bold'
          }}
        />
      ) : (
        <div
          style={{
            cursor: 'pointer',
            margin: 0,
            padding: 0,
            minHeight: '100px',
            fontWeight: 'bold'
          }}
        >
          {data.label || 'Double click to edit'}
        </div>
      )}
    </div>
  );
});



const WorkflowEditor = ({ activeDepartmentId, activeComplianceId, setMenuItem, setActiveRiskForWorkflow, setActiveAssetForWorkflow, partialNodes, partialEdges }) => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { flowcharts } = useSelector(state => state.workflows || {});
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [workflowDescription, setWorkflowDescription] = useState('');
  const { loading, error } = useSelector(state => state.workflows || {});
  const { currentFlowchart } = useSelector(state => state.workflows || {});
  const risks = useSelector((state) => state.workflows.risks);
  const assets = useSelector((state) => state.workflows.assets);
  const isOverlayOpen = useSelector((state) => state.risk.isOverlayOpen);
  const riskId = useSelector((state) => state.risk.id);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isControlOpen, setIsControlOpen] = useState(false);
  const [controlId, setControlId] = useState(null);
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [actionId, setActionId] = useState(null);

  const [openPanel, setOpenPanel] = useState(null); // 'shapes', 'ai', or null

  const location = useLocation();
  const [contextMenu, setContextMenu] = useState(null);


  const deleteElementById = useCallback((type, id) => {
    if (type === 'node') {
      setNodes((nds) => nds.filter((n) => n.id !== id));
      setEdges((eds) => eds.filter((e) => e.source !== id && e.target !== id));
    } else if (type === 'edge') {
      setEdges((eds) => eds.filter((e) => e.id !== id));
    }

    setContextMenu(null);
  }, [setNodes, setEdges]);


 const onNodeContextMenu = (event, node) => {
  event.preventDefault();

  const nodeEl = event.currentTarget.getBoundingClientRect();

  setContextMenu({
    type: "node",
    id: node.id,
    x: nodeEl.right + 8,
    y: nodeEl.top,
  });
};

  const onEdgeContextMenu = useCallback((event, edge) => {
    event.preventDefault();

    setContextMenu({
      type: 'edge',
      id: edge.id,
      x: event.clientX,
      y: event.clientY,
    });
  }, []);

  const duplicateNodeById = useCallback((id) => {
  setNodes((nds) => {
    const nodeToCopy = nds.find((n) => n.id === id);
    if (!nodeToCopy) return nds;

    const newId = `${nodeToCopy.type}-${Date.now()}`;

    const duplicatedNode = {
      ...nodeToCopy,
      id: newId,
      position: {
        x: nodeToCopy.position.x + 40,
        y: nodeToCopy.position.y + 40,
      },
      selected: false,
      data: {
        ...nodeToCopy.data,
      },
    };

    return [...nds, duplicatedNode];
  });

  setContextMenu(null);
}, [setNodes, setContextMenu]);


  const updateNodeSize = useCallback((id, width, height) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === id
          ? {
            ...node,
            data: {
              ...node.data,
              width,
              height,
            },
          }
          : node
      )
    );
  }, [setNodes]);

  const handleNodeChange = useCallback((id, value, field) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === id
          ? {
            ...node,
            data: {
              ...node.data,
              [field]: value,
            },
          }
          : node
      )
    );
  }, [setNodes]);


  const nodeTypes = React.useMemo(() => ({
    rectangle: ({ data, id, selected }) => (
      <div
        style={{
          width: data.width || 220,
          height: data.height || 120,
          background: '#fff',
          border: '1.5px solid',
          borderColor: selected ? '#2563EB' : '#6B7280',
          borderRadius: '6px',
          boxSizing: 'border-box',
          boxShadow: selected
            ? 'inset 0 0 0 1px #2563EB, 0 1px 2px rgba(0,0,0,0.06)'
            : '0 1px 2px rgba(0,0,0,0.06)',
          display: 'flex',
          flexDirection: 'column',
          fontSize: '14px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <NodeResizer
          isVisible={selected}
          minWidth={160}
          minHeight={100}
          color="#94A3B8"
          handleStyle={{
            width: 8,
            height: 8,
            borderRadius: 2,
            background: '#94A3B8',
            border: '1px solid white',
          }}
          lineStyle={{
            borderColor: '#CBD5E1',
          }}
          onResize={(event, params) => {
            updateNodeSize(id, params.width, params.height);
          }}
          onResizeEnd={(event, params) => {
            updateNodeSize(id, params.width, params.height);
          }}
        />

        <Handle type="target" id="left" position={Position.Left} style={handleStyle} />
        <Handle type="source" id="right" position={Position.Right} style={handleStyle} />
        <Handle type="source" id="top" position={Position.Top} style={handleStyle} />
        <Handle type="source" id="bottom" position={Position.Bottom} style={handleStyle} />

        <div
          style={{
            background: '#F9FAFB',
            borderBottom: '1px solid #D1D5DB',
            padding: '6px 8px',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        >
          {data.titleEditing ? (
            <input
              className="nodrag nowheel"
              autoFocus
              type="text"
              value={data.title || ''}
              onChange={(e) => handleNodeChange(id, e.target.value, 'title')}
              onBlur={() => handleNodeChange(id, false, 'titleEditing')}
              style={{
                width: '100%',
                border: 'none',
                background: 'transparent',
                textAlign: 'center',
                outline: 'none',
                fontWeight: '600',
                fontSize: '13px',
                color: '#374151',
              }}
              placeholder="Title"
            />
          ) : (
            <div
              onDoubleClick={() => handleNodeChange(id, true, 'titleEditing')}
              style={{
                width: '100%',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '13px',
                color: '#374151',
                cursor: 'grab',
                userSelect: 'none',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title="Double-click to edit"
            >
              {data.title || 'Title'}
            </div>
          )}
        </div>

        {data.isEditing ? (
          <textarea
            className="nodrag nowheel"
            autoFocus
            value={data.label || ''}
            onChange={(e) => handleNodeChange(id, e.target.value, 'label')}
            onBlur={() => handleNodeChange(id, false, 'isEditing')}
            style={{
              width: '100%',
              height: '100%',
              flex: 1,
              border: 'none',
              background: 'transparent',
              textAlign: 'center',
              outline: 'none',
              padding: '12px',
              resize: 'none',
              overflow: 'hidden',
              fontFamily: 'inherit',
              fontSize: 'inherit',
            }}
            placeholder="Process"
          />
        ) : (
          <div
            onDoubleClick={() => handleNodeChange(id, true, 'isEditing')}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              padding: '12px',
              cursor: 'grab',
              userSelect: 'none',
              whiteSpace: 'pre-wrap',
              overflow: 'hidden',
            }}
            title="Double-click to edit"
          >
            {data.label || 'Process'}
          </div>
        )}
      </div>
    ),

    oval: ({ data, id,  selected}) => (
      <div
        style={{
          width: '140px',
          height: '70px',
          background: '#fff',
         
          borderTopLeftRadius: '50px',
          borderBottomLeftRadius: '50px',
          borderTopRightRadius: '50px',
          borderBottomRightRadius: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          border: '1.5px solid',
          borderColor: selected ? '#2563EB' : '#6B7280',
          boxSizing: 'border-box',
          boxShadow: selected
            ? 'inset 0 0 0 1px #2563EB, 0 1px 2px rgba(0,0,0,0.06)'
            : '0 1px 2px rgba(0,0,0,0.06)',
          position: 'relative',
          padding: '10px 16px',
          boxSizing: 'border-box',
          cursor: 'grab',
        }}
      >
        <Handle type="target" id="in" position={Position.Left} style={handleStyle} />
        <Handle type="source" id="out" position={Position.Right} style={handleStyle} />

        <input
          className="nodrag nowheel"
          type="text"
          value={data.label || ''}
          onChange={(e) => handleNodeChange(id, e.target.value, 'label')}
          style={{
            width: '100%',
            border: 'none',
            background: 'transparent',
            textAlign: 'center',
            outline: 'none',
            fontSize: '14px',
            lineHeight: '18px',
            padding: 0,
          }}
          placeholder="Begin/End"
        />
      </div>
    ),

    diamond: ({ data, id, selected }) => (
      <div
        style={{
          width: '100px',
          height: '100px',
          background: '#fff',

          borderRadius: '5px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          transform: 'rotate(45deg)',
          border: '1.5px solid',
          borderColor: selected ? '#2563EB' : '#6B7280',
          boxSizing: 'border-box',
          boxShadow: selected
            ? 'inset 0 0 0 1px #2563EB, 0 1px 2px rgba(0,0,0,0.06)'
            : '0 1px 2px rgba(0,0,0,0.06)',
        }}
      >
        <Handle
          type="target"
          position={Position.Left}
          id="in"
          style={{
            ...handleStyle,
            position: 'absolute',
            top: '95%',
            left: '1%',
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          id="out-left"
          style={{
            ...handleStyle,
            position: 'absolute',
            left: '95%',
            top: '90%',
          }}
        />
        <Handle
          type="source"
          position={Position.Top}
          id="out-right"
          style={{
            ...handleStyle,
            position: 'absolute',
            right: '0%',
            top: '1%',
            left: '5%',
          }}
        />
        <div
          style={{
            transform: 'rotate(-45deg)',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {data.isEditing ? (
            <textarea
              className="nodrag nowheel"
              autoFocus
              value={data.label || ''}
              onChange={(e) => handleNodeChange(id, e.target.value, 'label')}
              onBlur={() => handleNodeChange(id, false, 'isEditing')}
              style={{
                width: '88%',
                height: '88%',
                border: 'none',
                background: 'transparent',
                textAlign: 'center',
                outline: 'none',
                padding: '8px',
                resize: 'none',
                overflowY: 'auto',
                overflowX: 'hidden',
                fontFamily: 'inherit',
                fontSize: 'inherit',
                lineHeight: '1.2',
                boxSizing: 'border-box',
                borderRadius: 0,
              }}
              placeholder="Decision"
            />
          ) : (
            <div
              onDoubleClick={() => handleNodeChange(id, true, 'isEditing')}
              style={{
                width: '68%',
                minHeight: '42%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: '6px',
                cursor: 'grab',
                userSelect: 'none',
                whiteSpace: 'pre-wrap',
                overflow: 'hidden',
              }}
              title="Double-click to edit"
            >
              {data.label || 'Decision'}
            </div>
          )}
        </div>
      </div>
    ),

    verticalLabelBlock: VerticalLabelBlock,
    riskNode: RiskNode,
    assetNode: AssetNode,
  }), [handleNodeChange, updateNodeSize]);

  const isComp = location.state?.isComp;
  // Fetch flowchart and risks when component mounts
  useEffect(() => {
    if (id) {
      dispatch(getFlowchartById(id));
    }
  }, [id, dispatch]);

  // Add effect to clear risks when component unmounts
  useEffect(() => {
    return () => {
      dispatch({ type: 'SET_FLOWCHARTS', payload: flowcharts });
    };
  }, [dispatch, flowcharts]);

  const [showRiskSelect, setShowRiskSelect] = useState(false);
  const [showAssetSelect, setShowAssetSelect] = useState(false);
  const [searchRisk, setSearchRisk] = useState('');
  const [searchAsset, setSearchAsset] = useState('');


  const flowWrapperRef = useRef(null);
  const [exportingPdf, setExportingPdf] = useState(false);

  const filteredRisks = risks && risks
    .filter(risk => {
      return (risk.title || risk.name || '').toLowerCase().includes(searchRisk.toLowerCase()) ||
        (risk.definition || risk.description || '').toLowerCase().includes(searchRisk.toLowerCase());
    })
    .slice(0, 5);

  const filteredAssets = assets && assets
    .filter(asset => {
      return (asset.name || asset.title || '').toLowerCase().includes(searchAsset.toLowerCase()) ||
        (asset.category || asset.description || '').toLowerCase().includes(searchAsset.toLowerCase());
    })
    .slice(0, 5);

  useEffect(() => {
    if (!id) {
      setNodes([]);
      setEdges([]);
      return;
    }



    const flowchart = flowcharts?.find(f => f.id === parseInt(id));
    if (flowchart) {
      setNodes([]);
      setEdges([]);

      let nodes = flowchart.nodes;
      let edges = flowchart.edges;

      if (typeof nodes === 'string') {
        try {
          nodes = JSON.parse(nodes);
        } catch (e) {
          nodes = [];
        }
      }

      if (typeof edges === 'string') {
        try {
          edges = JSON.parse(edges);
        } catch (e) {
          edges = [];
        }
      }

      const nodesWithHandlers = nodes.map(node => ({
        ...node,
        data: {
          ...node.data,
          label: node.data?.label || '',
          onChange: (nodeId, value) => {
            setNodes((nds) =>
              nds.map((n) => {
                if (n.id === nodeId) {
                  return {
                    ...n,
                    data: {
                      ...n.data,
                      label: value,
                    },
                  };
                }
                return n;
              })
            );
          }
        }
      })) || [];

      setNodes(nodesWithHandlers);
      setEdges(edges || []);
    } else {
      dispatch(getFlowchartById(id));
    }
  }, [id, flowcharts, dispatch]);



  useEffect(() => {
    if (currentFlowchart && currentFlowchart.id === parseInt(id)) {
      setNodes([]);
      setEdges([]);

      let nodes = currentFlowchart.nodes;
      let edges = currentFlowchart.edges;

      if (typeof nodes === 'string') {
        try {
          nodes = JSON.parse(nodes);
        } catch (e) {
          nodes = [];
        }
      }

      if (typeof edges === 'string') {
        try {
          edges = JSON.parse(edges);
        } catch (e) {
          edges = [];
        }
      }

      const nodesWithHandlers = nodes.map(node => ({
        ...node,
        data: {
          ...node.data,
          label: node.data?.label || '',
          title: node.data?.title || '',
          onChange: (nodeId, value, field) => {
            setNodes((nds) =>
              nds.map((n) => {
                if (n.id === nodeId) {
                  return {
                    ...n,
                    data: {
                      ...n.data,
                      [field]: value,
                    },
                  };
                }
                return n;
              })
            );
          }
        }
      })) || [];

      setNodes(nodesWithHandlers);
      setEdges(edges || []);
    }
  }, [currentFlowchart, id]);

  const onConnect = useCallback((params) => {
    const sourceId = params.source || '';
    const sourceHandle = params.sourceHandle || '';
    //console.log(sourceId)
    //console.log(sourceHandle)
    let label = 'Next';

    if (sourceId.startsWith('diamond-')) {
      if (sourceHandle === 'out-left') {
        label = 'No';
      } else {
        label = 'Yes';
      }
    }

    const edgeStyles = getEdgeLabelStyles(label);

    const newEdge = {
      ...params,
      type: 'smoothstep',
      label,

      sourcePosition:
        params.sourceHandle === 'top'
          ? 'top'
          : params.sourceHandle === 'bottom'
            ? 'bottom'
            : 'right',

      targetPosition:
        params.targetHandle === 'top'
          ? 'top'
          : params.targetHandle === 'bottom'
            ? 'bottom'
            : 'left',

      markerEnd: {
        type: 'arrowclosed',
        color: '#9CA3AF',
      },
      style: {
        stroke: '#9CA3AF',
        strokeWidth: 2,
      },
      labelBgPadding: [10, 4],
      labelBgBorderRadius: 999,
      ...edgeStyles,
    };

    setEdges((eds) => addEdge(newEdge, eds));
  }, [setEdges]);


  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     const isDeleteKey = e.key === 'Delete' || e.key === 'Backspace';
  //     if (!isDeleteKey) return;

  //     setNodes((nds) => nds.filter((n) => !n.selected));
  //     setEdges((eds) => eds.filter((e) => !e.selected));
  //   };

  //   window.addEventListener('keydown', handleKeyDown);
  //   return () => window.removeEventListener('keydown', handleKeyDown);
  // }, [setNodes, setEdges]);


  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  const onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  };

  const onDrop = (event) => {
    event.preventDefault();
    if (!reactFlowInstance) return;

    const type = event.dataTransfer.getData('application/reactflow');
    const position = reactFlowInstance.screenToFlowPosition({
      x: event.clientX,
      y: event.clientY,
    });

    const newNode = {
      id: `${type}-${nodes?.length + 1}`,
      type,
      position,
      data: {
        label: '',
        title: '',
        onChange: (nodeId, value, field) => {
          setNodes((nds) =>
            nds.map((node) => {
              if (node.id === nodeId) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    [field]: value,
                  },
                };
              }
              return node;
            })
          );
        }
      },
      style: type === 'verticalLabelBlock' ? {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '30px',
        backgroundColor: 'white',
        borderRight: '2px solid black',
        writingMode: 'vertical-lr',
        textOrientation: 'upright',
        fontWeight: 'bold',
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        pointerEvents: 'auto',
        cursor: 'text'
      } : undefined
    };

    setNodes((nds) => nds.concat(newNode));
  };

  const handleSaveAndExit = () => {
    dispatch(updateFlowchart(id, nodes, edges));
    //console.log("isComp", isComp)
    if (isComp) {
      history.push('/risk_center', {
        activeMenuItem: 'workflows',
        ComplianceFromRedirect: activeComplianceId
      });
    } else {
      history.push('/risk_center', {
        activeMenuItem: 'workflows',
        departmentfromredirect: activeDepartmentId
      });
    }
  };

  const handleSendDescription = async () => {
    try {
      const result = await dispatch(generateFlowchartFromDescription(workflowDescription, nodes, edges));
      ////console.log('Generated flowchart:', result);
      setNodes(result.nodes || []);
      setEdges(result.edges || []);
    } catch (err) {
      console.error('Failed to generate flowchart:', err);
    }

  };
  useEffect(() => {
    // ignore the very first render (empty arrays) if you like:
    if (!partialNodes && !partialEdges) return;
    ////console.log("PARTIAL NODES", partialNodes)
    // add onChange callback so the user can still edit the streamed-in nodes
    const nodesWithHandlers = partialNodes.map((node) => ({
      ...node,
      data: {
        ...node.data,
        onChange: (nodeId, value, field = "label") =>
          setNodes((nds) =>
            nds.map((n) =>
              n.id === nodeId
                ? { ...n, data: { ...n.data, [field]: value } }
                : n
            )
          ),
      },
    }));

    setNodes(nodesWithHandlers);
    setEdges(partialEdges);          // edges don’t need extra work
  }, [partialNodes, partialEdges]);

  const handleNodeClick = (event, type) => {
    event.preventDefault();
    if (type === 'risk') {
      setShowRiskSelect(!showRiskSelect);
      setShowAssetSelect(false);
      setSearchRisk('');
    } else if (type === 'asset') {
      setShowAssetSelect(!showAssetSelect);
      setShowRiskSelect(false);
      setSearchAsset('');
    }
  };

  const renderDropdown = (type, items, searchValue, setSearchValue) => {
    // Calculate position based on current viewport
    const calculatePosition = () => {
      if (!reactFlowInstance) {
        return { x: 100, y: 100 }; // Fallback if reactFlowInstance is not available
      }

      // Get the ReactFlow container element
      const container = document.querySelector('.react-flow');
      if (!container) {
        return { x: 100, y: 100 }; // Fallback if container not found
      }

      const { width, height } = container.getBoundingClientRect();

      // Convert screen coordinates to flow coordinates
      return reactFlowInstance.screenToFlowPosition({
        x: width / 2,
        y: height / 2
      });
    };

    return (
      <div
        className="node-dropdown"
        style={{
          position: 'absolute',
          left: '100%',
          top: 0,
          background: 'white',
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '10px',
          zIndex: 1000,
          minWidth: '200px',
          maxWidth: '300px',
          boxSizing: 'border-box'
        }}
      >
        <div style={{ position: 'relative', marginBottom: '8px' }}>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder={`Search ${type}...`}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              boxSizing: 'border-box',
              outline: 'none'
            }}
            autoFocus
          />
        </div>
        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
          {items && items?.length > 0 ? (
            items.map((item) => {
              const itemId = type === 'risk' ? item.risk_id : item.id;

              if (!itemId) {
                return null;
              }

              return (
                <div
                  key={`${type}-${itemId}`}
                  onClick={() => {
                    const position = calculatePosition();
                    const itemId = type === 'risk' ? item.risk_id : item.id;

                    if (!itemId) {
                      return;
                    }

                    const newNode = {
                      id: `${type}_${itemId}_${Date.now()}`,
                      type: `${type}Node`,
                      position,
                      data: {
                        id: itemId,
                        name: item.title || item.name,
                        definition: item.definition || item.description || item.category,
                        setMenuItem: setMenuItem,
                        setActiveRiskForWorkflow: setActiveRiskForWorkflow,
                        setActiveAssetForWorkflow: setActiveAssetForWorkflow
                      }
                    };
                    setNodes((nds) => nds.concat(newNode));
                    if (type === 'risk') {
                      setShowRiskSelect(false);
                    } else {
                      setShowAssetSelect(false);
                    }
                  }}
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eee',
                    ':hover': {
                      background: '#f5f5f5'
                    }
                  }}
                >
                  <div style={{ fontWeight: 'bold' }}>
                    {item.title || item.name}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    {item.definition || item.description || item.category}
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ padding: '8px 12px', color: '#666' }}>
              No {type}s found
            </div>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (isOverlayOpen) {
      setIsPopupOpen(true);
    }
  }, [isOverlayOpen]);

  const closePopup = () => {
    setIsPopupOpen(false);
    dispatch(closeOverlay());
  };

  useEffect(() => {
    const closeMenu = () => setContextMenu(null);

    window.addEventListener('click', closeMenu);
    return () => window.removeEventListener('click', closeMenu);
  }, []);


  const handleExportPdf = useCallback(async () => {
    if (!reactFlowInstance || !nodes?.length) return;

    try {
      setExportingPdf(true);

      const nodesBounds = getRectOfNodes(nodes);

      const exportPadding = 80;
      const imageWidth = Math.max(nodesBounds.width + exportPadding * 2, 1400);
      const imageHeight = Math.max(nodesBounds.height + exportPadding * 2, 900);

      const transform = getTransformForBounds(
        nodesBounds,
        imageWidth,
        imageHeight,
        0.9,
        2
      );

      const viewport = flowWrapperRef.current?.querySelector('.react-flow__viewport');
      if (!viewport) throw new Error('Could not find workflow viewport');

      const dataUrl = await toPng(viewport, {
        backgroundColor: '#ffffff',
        pixelRatio: 2.5,
        width: imageWidth,
        height: imageHeight,
        style: {
          width: `${imageWidth}px`,
          height: `${imageHeight}px`,
          transform: `translate(${transform[0] + exportPadding}px, ${transform[1] + exportPadding}px) scale(${transform[2]})`,
        },
        filter: (node) => {
          // hide controls/minimap/tool UI from PDF if needed
          const className = typeof node.className === 'string' ? node.className : '';
          return !className.includes('react-flow__controls');
        },
      });

      const workflowName =
        flowcharts?.find((f) => f.id === parseInt(id))?.name || 'Untitled Workflow';

      const today = new Date();
      const formattedDate = today.toLocaleDateString('en-CA'); // YYYY-MM-DD

      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4',
        compress: true,
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const margin = 10;
      const headerHeight = 16;
      const usableWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2 - headerHeight;

      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(14);
      pdf.text(workflowName, margin, 10);

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(9);
      pdf.text(`Exported from Rabo • ${formattedDate}`, margin, 15);

      const imgProps = pdf.getImageProperties(dataUrl);
      const imgRatio = imgProps.width / imgProps.height;

      let renderWidth = usableWidth;
      let renderHeight = renderWidth / imgRatio;

      // if height fits, keep single page
      if (renderHeight <= usableHeight) {
        pdf.addImage(
          dataUrl,
          'PNG',
          margin,
          margin + headerHeight,
          renderWidth,
          renderHeight,
          undefined,
          'FAST'
        );
      } else {
        // multi-page fallback
        renderHeight = usableHeight;
        renderWidth = renderHeight * imgRatio;

        // if still too wide, clamp to usable width
        if (renderWidth > usableWidth) {
          renderWidth = usableWidth;
          renderHeight = renderWidth / imgRatio;
        }

        const fullImgHeightMm = usableWidth / imgRatio;
        const pageImgHeightPx = (usableHeight / fullImgHeightMm) * imgProps.height;

        let remainingPx = imgProps.height;
        let pageIndex = 0;

        while (remainingPx > 0) {
          if (pageIndex > 0) {
            pdf.addPage();

            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(14);
            pdf.text(workflowName, margin, 10);

            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(9);
            pdf.text(`Exported from Rabo • ${formattedDate} • Page ${pageIndex + 1}`, margin, 15);
          }

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          const sliceHeightPx = Math.min(pageImgHeightPx, remainingPx);
          canvas.width = imgProps.width;
          canvas.height = sliceHeightPx;

          const img = new Image();
          img.src = dataUrl;

          await new Promise((resolve, reject) => {
            img.onload = () => {
              ctx.drawImage(
                img,
                0,
                pageIndex * pageImgHeightPx,
                imgProps.width,
                sliceHeightPx,
                0,
                0,
                imgProps.width,
                sliceHeightPx
              );
              resolve();
            };
            img.onerror = reject;
          });

          const sliceDataUrl = canvas.toDataURL('image/png');
          const sliceHeightMm = (sliceHeightPx / imgProps.height) * fullImgHeightMm;

          pdf.addImage(
            sliceDataUrl,
            'PNG',
            margin,
            margin + headerHeight,
            usableWidth,
            sliceHeightMm,
            undefined,
            'FAST'
          );

          remainingPx -= sliceHeightPx;
          pageIndex += 1;
        }
      }

      const safeName = workflowName.replace(/[\\/:*?"<>|]/g, '_');
      pdf.save(`Workflow_${safeName}_${formattedDate}.pdf`);
    } catch (err) {
      console.error('PDF export failed:', err);
    } finally {
      setExportingPdf(false);
    }
  }, [reactFlowInstance, nodes, flowcharts, id]);

  return (
    <div className="flex flex-col h-full w-full">
      <TopBar />
      <div className="flex flex-col w-full p-4 ">
        <div className="flex items-center justify-between mb-4 px-2">

  {/* LEFT: Tabs */}
  <div className="flex items-center gap-2">
    <div className="px-4 py-2 bg-white border border-gray-200 rounded-md shadow-sm text-[14px] font-medium text-gray-700">
      {flowcharts?.find(f => f.id === parseInt(id))?.name || 'Untitled Workflow'}
    </div>

    <button className="px-3 py-2 text-[13px] border border-gray-200 rounded-md bg-[#F8F8F8] hover:bg-[#F0F0F2]">
      + Page
    </button>
  </div>

  {/* RIGHT: Actions */}
  <div className="flex items-center gap-2">

    <button
      onClick={handleSaveAndExit}
      className="px-4 py-2 text-[13px] rounded-md bg-white border border-gray-300 hover:bg-gray-50 shadow-sm"
    >
      Save
    </button>

    <button
      onClick={handleExportPdf}
      disabled={exportingPdf || !nodes?.length}
      className={`px-4 py-2 text-[13px] rounded-md border shadow-sm ${
        exportingPdf || !nodes?.length
          ? 'bg-gray-100 text-gray-400 border-gray-200'
          : 'bg-white hover:bg-gray-50 border-gray-300'
      }`}
    >
      Export
    </button>

  </div>
</div>


        <div className="flex h-full w-full">




          <div
            ref={flowWrapperRef}
            className="flex-grow h-[calc(100vh-200px)] border border-gray-300 rounded-lg bg-white relative"
          >

            <div className="w-12 bg-transparent flex flex-col items-center pt-4 space-y-4 z-10 absolute top-4 left-4">
              <button
                onClick={() => setOpenPanel(openPanel === 'shapes' ? null : 'shapes')}
                className="w-12 h-12 bg-white border rounded shadow-md hover:shadow-xl flex items-center justify-center"
              >
                <RiFlowChart size={16} />
              </button>
              <button
                onClick={() => setOpenPanel(openPanel === 'ai' ? null : 'ai')}
                className="w-12 h-12 bg-white border rounded shadow-md hover:shadow-xl flex items-center justify-center"
              >
                <BsStars size={16} />
              </button>
            </div>

            {openPanel === 'shapes' && (
              <div className="absolute top-4 left-16 w-24 bg-transparent p-4 rounded-lg  z-10 flex flex-col items-center space-y-4">
                {/* Rectangle */}
                <div
                  className="w-12 h-12 bg-white border border-gray-300 rounded-lg cursor-grab flex items-center justify-center hover:shadow-xl shadow-md"
                  draggable
                  onDragStart={(e) => onDragStart(e, 'rectangle')}
                >
                  <div className="w-8 h-4 bg-gray-200 border border-black" />
                </div>

                {/* Oval */}
                <div
                  className="w-12 h-12 bg-white border border-gray-300 rounded-lg cursor-grab flex items-center justify-center hover:shadow-xl shadow-md"
                  draggable
                  onDragStart={(e) => onDragStart(e, 'oval')}
                >
                  <div className="w-8 h-5 bg-gray-200 rounded-full border border-black" />
                </div>

                {/* Diamond */}
                <div
                  className="w-12 h-12 bg-white border border-gray-300 rounded-lg cursor-grab flex items-center justify-center hover:shadow-xl shadow-md"
                  draggable
                  onDragStart={(e) => onDragStart(e, 'diamond')}
                >
                  <div
                    className="w-5 h-5 bg-gray-200 border border-black"
                    style={{ transform: 'rotate(45deg)' }}
                  />
                </div>

                {/* Label Block */}
                <div
                  className="w-12 h-12 bg-white border border-gray-300 rounded-lg cursor-grab flex items-center justify-center hover:shadow-xl shadow-md"
                  draggable
                  onDragStart={(e) => onDragStart(e, 'verticalLabelBlock')}
                >
                  <div className="w-2 h-8 bg-gray-200 border border-black" />
                </div>

                {/* Risk */}
                <div
                  className="w-12 h-12 bg-white border-2 rounded-lg cursor-pointer flex items-center justify-center hover:shadow-xl shadow-md"
                  onClick={(e) => handleNodeClick(e, 'risk')}
                  style={{ borderColor: '#e74c3c' }}
                >
                  <div className="w-8 h-8 bg-[#e74c3c] rounded-sm" />
                  {showRiskSelect && renderDropdown('risk', filteredRisks, searchRisk, setSearchRisk)}
                </div>

                {/* Asset */}
                <div
                  className="w-12 h-12 bg-white border-2 rounded-lg cursor-pointer flex items-center justify-center hover:shadow-xl shadow-md"
                  onClick={(e) => handleNodeClick(e, 'asset')}
                  style={{ borderColor: '#27ae60' }}
                >
                  <div className="w-8 h-8 bg-[#27ae60] rounded-sm" />
                  {showAssetSelect && renderDropdown('asset', filteredAssets, searchAsset, setSearchAsset)}

                </div>
              </div>
            )}


            {openPanel === 'ai' && (
              <div className="absolute top-8 left-20 w-[28rem] bg-white p-6 rounded-xl shadow-lg z-10 border border-gray-200">
                <h3 className="text-lg font-semibold mb-4 text-gray-800">
                  Workflow description
                </h3>

                {/*  ➜ taller textarea */}
                <textarea
                  value={workflowDescription}
                  onChange={(e) => setWorkflowDescription(e.target.value)}
                  placeholder="Describe the workflow you want to create…"
                  className="w-full h-56 resize-none p-4 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                {/*  buttons */}
                <div className="flex justify-end items-center gap-3 mt-4">
                  {/* Clear All – small, flat, subtle shine on hover */}
                  <button
                    onClick={() => setWorkflowDescription('')}
                    disabled={loading}
                    className={`
          relative text-sm rounded px-4 py-2 border border-gray-300
          overflow-hidden transition
          ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-md'}
        `}
                    style={{
                      background:
                        'linear-gradient(90deg,#f8f8f8 0%,#f0f0f0 50%,#f8f8f8 100%)',
                      boxShadow: '0 0 4px rgba(0,0,0,0.08)',
                    }}
                  >
                    <span className="relative text-gray-700">Clear all</span>
                  </button>

                  {/* Ask Rabo – same size, but colourful & pulsing when loading */}
                  <button
                    onClick={handleSendDescription}
                    disabled={loading}
                    className={`
          relative text-sm rounded px-4 py-2 text-white
          transition duration-300 ease-in-out
          ${loading ? 'animate-pulse cursor-wait' : 'hover:shadow-xl hover:scale-[1.04]'}
        `}
                    style={{
                      background:
                        'linear-gradient(90deg,#3b82f6 0%,#8b5cf6 50%,#ec4899 100%)',
                      minWidth: '7.5rem',
                      boxShadow: loading
                        ? '0 0 14px 4px rgba(139,92,246,.6)'
                        : '0 3px 6px rgba(0,0,0,.15)',
                    }}
                  >
                    <span className="absolute inset-0 rounded blur-md opacity-50"
                      style={{
                        background:
                          'linear-gradient(90deg,#3b82f6 0%,#8b5cf6 50%,#ec4899 100%)',
                      }} />
                    <span className="relative">Ask Rabo</span>
                  </button>
                </div>

                {error && (
                  <p className="text-red-500 text-xs mt-3">{error}</p>
                )}
              </div>
            )}


            <ReactFlow
              nodes={nodes}
              edges={edges}
              nodeTypes={nodeTypes}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onInit={setReactFlowInstance}
              onNodeContextMenu={onNodeContextMenu}
              onEdgeContextMenu={onEdgeContextMenu}
              onNodeDragStart={() => setContextMenu(null)}
              onDrop={onDrop}
              onDragOver={onDragOver}
              fitView
              attributionPosition={null}
              connectionLineType="smoothstep"
              defaultEdgeOptions={{
                type: 'smoothstep',
                markerEnd: {
                  type: 'arrowclosed',
                  width: 18,
                  height: 18,
                  color: '#9CA3AF',
                },
                style: {
                  stroke: '#9CA3AF',
                  strokeWidth: 2,
                },
                labelStyle: {
                  fontSize: 12,
                  fontWeight: 600,
                  fill: '#374151',
                },
                labelBgPadding: [10, 4],
                labelBgBorderRadius: 999,
                labelBgStyle: {
                  fill: '#F3F4F6',
                  stroke: '#D1D5DB',
                  strokeWidth: 1,
                },
              }}

            >
              <Background />
              <Controls />
            </ReactFlow>
          </div>
        </div>
      </div>
   {contextMenu && (
  <div
    style={{
      position: "fixed",
      top: contextMenu.y,
      left: contextMenu.x,
      background: "#fff",
      border: "1px solid #E5E7EB",
      borderRadius: 8,
      boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
      zIndex: 1000,
      padding: "6px",
      minWidth: 145,
    }}
    onClick={(e) => e.stopPropagation()}
  >
    {contextMenu.type === "node" && (
      <button
        onClick={() => duplicateNodeById(contextMenu.id)}
        className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-[12px] text-[#111827] hover:bg-[#F3F4F6]"
      >
        <i className="far fa-copy text-[12px] text-gray-500" />
        Duplicate
      </button>
    )}

    <button
      onClick={() => deleteElementById(contextMenu.type, contextMenu.id)}
      className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-[12px] text-[#DC2626] hover:bg-[#FEE2E2]"
    >
      <i className="far fa-trash-alt text-[12px]" />
      Delete
    </button>
  </div>
)}
      <Popup
        open={isPopupOpen}
        onClose={closePopup}
        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
      >
        <RiskDetailsForm
          close={closePopup}
          risk_id={riskId}
          openControl={() => setIsControlOpen(true)}
          setControlId={setControlId}
          controlopen={isControlOpen}
          openAction={() => setIsActionOpen(true)}
          setActionId={setActionId}
          actionopen={isActionOpen}
        />
      </Popup>

      <Popup
        open={isControlOpen}
        onClose={() => setIsControlOpen(false)}
        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
      >
        <ControlOverlay
          key={controlId || 'new-control'}
          closeControl={() => setIsControlOpen(false)}
          risk_id={riskId}
          control_id={controlId}
        />
      </Popup>

      <Popup
        open={isActionOpen}
        onClose={() => setIsActionOpen(false)}
        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}
      >
        <ActionOverlay
          closeAction={() => setIsActionOpen(false)}
          risk_id={riskId}
          action_id={actionId}
        />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  partialNodes: state.workflows.partialNodes,
  partialEdges: state.workflows.partialEdges,
  activeDepartmentId: state.department.activeDepartmentId,
  activeComplianceId: state.compliance.activeComplianceId

});


export default compose(connect(mapStateToProps))(WorkflowEditor); 